// components/LineStatusPopover.jsx
import React, { useState } from "react";
import { Button, Popover, List, ListItem, Typography } from "@mui/material";
import moment from "moment";

const LineStatusPopover = ({ lines }) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? "line-status-popover" : undefined;

	if (!lines || !lines.length) {return null;}

	return (
		<>
			<Button
				size="small"
				variant="text"
				sx={{ mt: 0.5, textTransform: "none", p: 0 }}
				onClick={handleOpen}
			>
				View Lines
			</Button>

			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<List dense sx={{ p: 2, minWidth: 220 }}>
					{lines.map((line, index) => (
						<ListItem
							key={index}
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								py: 0.5,
							}}
						>
							<Typography variant="body2" noWrap maxWidth={140}>
								{line.title}
							</Typography>
							<Typography
								variant="body2"
								// color="text.secondary"
								sx={{ whiteSpace: "nowrap", ml: 2 }}
							>
								{moment(line.changed_at).format(
									"DD MMM, hh:mm A"
								)}
							</Typography>
						</ListItem>
					))}
				</List>
			</Popover>
		</>
	);
};

export default LineStatusPopover;
